import { computed } from "@vue/composition-api";
import { checkByAuthorities } from "@/lib/helpers/componentViewController";
import store from "@/store";

export default function useAuthorityCheck(ruleName: string, ruleKey: string) {
  return computed(() => checkByAuthorities((store.state as any).loggedInUser.authorities, ruleName, ruleKey));
}
